<ng-container
  *ngIf="{
    facets: facets$ | async,
  } as content"
>
  <div class="facets-container">
    <div *ngIf="content.facets?.appliedFacets?.length" class="simple-card">
      <facets-applied [facets]="content.facets?.appliedFacets!"></facets-applied>
    </div>

    @if (!content.facets?.facetGroups?.isLoading) {
      <div *ngIf="content.facets?.facetGroups" class="simple-card">
        <facets-to-apply [facetGroups]="content.facets?.facetGroups || {}"></facets-to-apply>
      </div>
    } @else {
      <local-loader />
    }
  </div>
</ng-container>
